import storeModule from './store'

export { default as Notifications } from './components/notifications.vue'
export { default as NotificationsLoader } from './components/notifications-loader.vue'

let config

const validateOptions = (options) => {
  if (!options.store) throw new Error('Please provide a Vuex store')

  options.openLinksInNewWindow = options.openLinksInNewWindow || false
  return options
}

const registerStoreModule = () => {
  config.store.registerModule('notifications', storeModule)
}

export default {
  install (Vue, options) {
    config = validateOptions(options)
    Vue.prototype.$_notifications_config = config
    registerStoreModule()
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/notifications/index.js